// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"99b3d4f91a739734","931":"81a1d1b83b8710ea"}[chunkId] + ".css";
};